import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import male from 'src/assets/Buy_Policy_Images/BoyIcon.svg'
import female from 'src/assets/Buy_Policy_Images/GirlIcon.svg'
import fatherInLaw from 'src/assets/Buy_Policy_Images/grandFather.svg'
import motherInLaw from 'src/assets/Buy_Policy_Images/motherInLaw.svg'
import { useSelector } from 'react-redux'
import {
  GENDER_TYPE_ENUMS,
  HEALTH_ROUTES,
  SPOUSE_GENDER_TYPE_ENUMS,
} from 'src/utils/constants/BuyPolicy'
import {
  addScroll,
  getUrlLastRoute,
  removeScroll,
} from 'src/utils/commonMethods'
import StatusBar from 'src/components/BuyPolicy/insuranceScreens/health/StatusBar'
import Modal from '@mui/material/Modal'
import FamilyMembersModal from 'src/components/BuyPolicy/insuranceScreens/health/FamilyMembersModal.js'
import {
  getGenderLogo,
  isKidsPresent,
  isValidAge,
  redirectToHealthHomePage,
} from 'src/utils/commonMethods/buyPolicy'
import { useHistory, useLocation } from 'react-router-dom'
import { STEPPER_CONSTANTS } from 'src/utils/constants/Health'

const FamilyMemberDetails = () => {
  const classes = useStyles()
  const urlLastRoute = getUrlLastRoute()
  const history = useHistory()
  const { search } = useLocation()
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const enquiryId = searchParams.get('enquiryId')
  const [statusValues, setStatusValues] = useState({
    first: 0,
    second: 0,
    third: 0,
    fourth: 0,
  })

  const [modalOpen, setModalOpen] = useState(false)

  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)

  const userDetails = guestUserDetails?.userDetails
  const ageDetails = guestUserDetails?.userDetails?.ageDetails

  const handleStepperProgress = () => {
    switch (urlLastRoute) {
      case STEPPER_CONSTANTS?.HEALTH:
        setStatusValues({
          first: 0,
          second: 0,
          third: 0,
          fourth: 0,
        })
        break
      case STEPPER_CONSTANTS?.INSURANCE_DETAILS:
      case STEPPER_CONSTANTS?.PLAIN_DETAILS:
        setStatusValues({
          first: 100,
          second: 40,
          third: 0,
          fourth: 0,
        })
        break
      case STEPPER_CONSTANTS?.MEMBER_DETAILS:
        setStatusValues({
          first: 100,
          second: 100,
          third: 40,
          fourth: 0,
        })
        break
      case STEPPER_CONSTANTS?.MEDICAL_CONDITION:
        setStatusValues({
          first: 100,
          second: 100,
          third: 100,
          fourth: 40,
        })
        break
      default:
        setStatusValues({
          first: 100,
          second: 100,
          third: 100,
          fourth: 100,
        })
        break
    }
  }

  useEffect(() => {
    handleStepperProgress()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname])

  useEffect(() => {
    if (modalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [modalOpen])

  useEffect(() => {
    if (!enquiryId) {
      redirectToHealthHomePage(guestUserDetails, history)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleModel = (modal) => {
    if (!disableUserDetailsEdit()) {
      setModalOpen(modal)
    }
  }

  const disableUserDetailsEdit = () => {
    return (
      urlLastRoute?.includes(HEALTH_ROUTES?.termsAndConditions) ||
      urlLastRoute?.includes(HEALTH_ROUTES?.medicalCondition)
    )
  }

  return (
    <>
      {modalOpen ? (
        <Modal open={modalOpen} onClose={() => handleModel(false)} id='modal'>
          <div className={`${classes.modalRoot} modal-container`}>
            <FamilyMembersModal
              id='familyMembersModal'
              onEdit={() => handleModel(false)}
            />
          </div>
        </Modal>
      ) : null}

      <div className={classes.rootContainer}>
        <div className={classes.boxContainer}>
          <div className={classes.statusBarContainer}>
            <StatusBar statusValues={statusValues} />
          </div>
          {!disableUserDetailsEdit() ? (
            <div className={classes.textContainer}>
              <p className={classes.textContent} id='Text'>
                Click on the icons to modify your family member details.
              </p>
            </div>
          ) : null}
          <div className={classes.iconContainer}>
            {ageDetails?.myAge ? (
              <div className={classes.relationContainer}>
                <div
                  className={`${classes.relationBtn} ${
                    disableUserDetailsEdit() ? '' : 'cursor-pointer'
                  }`}
                  onClick={() => handleModel(true)}
                  id='relationSelf'
                >
                  <div className={classes.characterImageContainer}>
                    <img
                      src={getGenderLogo(userDetails?.gender)}
                      alt='Self'
                      className={classes.characterImage}
                    />
                  </div>
                </div>
                <p className={classes.relationLabel}>
                  {ageDetails?.myAge ? `Self (${ageDetails?.myAge} Y)` : 'Self'}
                </p>
              </div>
            ) : null}

            {ageDetails?.spouseAge ? (
              <div className={classes.relationContainer}>
                <div
                  className={`${classes.relationBtn} ${
                    disableUserDetailsEdit() ? '' : 'cursor-pointer'
                  }`}
                  onClick={() => handleModel(true)}
                  id='relationSpouse'
                >
                  <div className={classes.characterImageContainer}>
                    <img
                      src={getGenderLogo(
                        SPOUSE_GENDER_TYPE_ENUMS[userDetails?.gender]
                      )}
                      alt='Spouse'
                      className={classes.characterImage}
                    />
                  </div>
                </div>
                <p className={classes.relationLabel}>
                  {ageDetails?.spouseAge
                    ? `Spouse (${ageDetails?.spouseAge} Y)`
                    : 'Spouse'}
                </p>
              </div>
            ) : null}
            {isKidsPresent(GENDER_TYPE_ENUMS?.MALE, ageDetails?.kidsAge)
              ? ageDetails?.kidsAge
                  ?.filter(
                    (kidDetails) =>
                      isValidAge(kidDetails?.age) &&
                      kidDetails?.gender === GENDER_TYPE_ENUMS?.MALE
                  )
                  ?.map((kid) => (
                    <div key={kid?.id} className={classes.relationContainer}>
                      <div
                        className={`${classes.relationBtn} ${
                          disableUserDetailsEdit() ? '' : 'cursor-pointer'
                        }`}
                        onClick={() => handleModel(true)}
                        id={`relationKids-${kid?.id}`}
                      >
                        <div className={classes.characterImageContainer}>
                          <img
                            src={male}
                            alt='Boy'
                            className={classes.characterImage}
                          />
                        </div>
                      </div>
                      <p className={classes.relationLabel}>
                        Boy ({kid?.age} Y)
                      </p>
                    </div>
                  ))
              : null}

            {isKidsPresent(GENDER_TYPE_ENUMS?.FEMALE, ageDetails?.kidsAge)
              ? ageDetails?.kidsAge
                  ?.filter(
                    (kidDetails) =>
                      isValidAge(kidDetails?.age) &&
                      kidDetails?.gender === GENDER_TYPE_ENUMS?.FEMALE
                  )
                  .map((kid) => (
                    <div key={kid.id} className={classes.relationContainer}>
                      <div
                        className={`${classes.relationBtn} ${
                          disableUserDetailsEdit() ? '' : 'cursor-pointer'
                        }`}
                        onClick={() => handleModel(true)}
                        id={`relationKids-${kid?.id}`}
                      >
                        <div className={classes.characterImageContainer}>
                          <img
                            src={female}
                            alt='Girl'
                            className={classes.characterImage}
                          />
                        </div>
                      </div>
                      <p className={classes.relationLabel}>
                        Girl ({kid?.age} Y)
                      </p>
                    </div>
                  ))
              : null}

            {ageDetails?.fatherAge ? (
              <div className={classes.relationContainer}>
                <div
                  className={`${classes.relationBtn} ${
                    disableUserDetailsEdit() ? '' : 'cursor-pointer'
                  }`}
                  onClick={() => handleModel(true)}
                  id='relationParents'
                >
                  <div className={classes.characterImageContainer}>
                    <img
                      src={fatherInLaw}
                      alt='Father'
                      className={classes.characterImage}
                    />
                  </div>
                </div>
                <p className={classes.relationLabel}>
                  {ageDetails?.fatherAge
                    ? `Father (${ageDetails?.fatherAge} Y)`
                    : 'Father'}
                </p>
              </div>
            ) : null}

            {ageDetails?.motherAge ? (
              <div className={classes.relationContainer}>
                <div
                  className={`${classes.relationBtn} ${
                    disableUserDetailsEdit() ? '' : 'cursor-pointer'
                  }`}
                  onClick={() => handleModel(true)}
                  id='relationParents'
                >
                  <div className={classes.characterImageContainer}>
                    <img
                      src={motherInLaw}
                      alt='Mother'
                      className={classes.characterImage}
                    />
                  </div>
                </div>
                <p className={classes.relationLabel}>
                  {ageDetails?.motherAge
                    ? `Mother(${ageDetails?.motherAge} Y)`
                    : 'Mother'}
                </p>
              </div>
            ) : null}

            {ageDetails?.fatherInLawAge ? (
              <div className={classes.relationContainer}>
                <div
                  className={`${classes.relationBtn} ${
                    disableUserDetailsEdit() ? '' : 'cursor-pointer'
                  }`}
                  onClick={() => handleModel(true)}
                  id='relationInLaws'
                >
                  <div className={classes.characterImageContainer}>
                    <img
                      src={fatherInLaw}
                      alt='Father In Law'
                      className={classes.characterImage}
                    />
                  </div>
                </div>
                <p className={classes.relationLabel}>
                  {ageDetails?.fatherInLawAge
                    ? `Father In Law (${ageDetails?.fatherInLawAge} Y)`
                    : 'Father In Law'}
                </p>
              </div>
            ) : null}

            {ageDetails?.motherInLawAge ? (
              <div className={classes.relationContainer}>
                <div
                  className={`${classes.relationBtn} ${
                    disableUserDetailsEdit() ? '' : 'cursor-pointer'
                  }`}
                  onClick={() => handleModel(true)}
                  id='relationInLaws'
                >
                  <div className={classes.characterImageContainer}>
                    <img
                      src={motherInLaw}
                      alt='Mother In Law'
                      className={classes.characterImage}
                    />
                  </div>
                </div>
                <p className={classes.relationLabel}>
                  {ageDetails?.motherInLawAge
                    ? `Mother In Law (${ageDetails?.motherInLawAge} Y)`
                    : 'Mother In Law'}
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}
export default FamilyMemberDetails
const useStyles = makeStyles({
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  boxContainer: {
    background: 'linear-gradient(185.98deg, #CEF3FF -18.56%, #FFFFFF 67.98%)',
    boxShadow: '0px 4px 4px 0px #0000001A',
    borderRadius: '10px',
    padding: '20px',
  },
  textContent: {
    fontSize: '12px',
    fontWeight: '400',
    textAlign: 'center',
    color: '#83ABB7',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    '@media (max-width:770px)': { gap: '3px' },
  },
  coupleContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
  },
  selfActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  spouseActions: {
    display: 'flex',
    flexDirection: 'column',
  },
  selfContent: {
    fontSize: '11px',
    fontWeight: '400',
    textAlign: 'center',
  },
  spouseContent: {
    fontSize: '11px',
    fontWeight: '400',
    textAlign: 'center',
    MarginTop: '10px',
  },
  maleActions: {
    display: 'flex',
    flexDirection: 'row',
  },
  inLawActions: {
    display: 'flex',
    flexDirection: 'row',
  },
  inLawContent: {
    fontSize: '11px',
    fontWeight: '400',
    textAlign: 'center',
  },
  activeStepIcon: {
    color: '#4DC3E3',
  },
  relationBtn: {
    padding: 'unset !important',
    display: 'flex',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    justifyContent: 'center',
    alignItems: 'center',
  },
  characterImageContainer: {
    width: '24px',
    height: '40px',
  },
  characterImage: {
    width: '100%',
    height: '100%',
  },
  relationLabel: {
    fontSize: '11px',
    fontWeight: '400',
    textAlign: 'center',
  },
  relationContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '8px',
  },
  ageSelectContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  },
  ageSelectHeading: {
    fontSize: '11px',
    marginBottom: '5px',
  },
  statusBarContainer: {
    marginBottom: '30px',
    marginTop: '5px',
  },
  modalRoot: {
    // maxWidth: '600px',
    // maxHeight: '90%',
    // width: '60%',
  },
})
